var map = {
	"./logo-client.svg": "a390",
	"./logo-console.svg": "5358",
	"./logo-genesis-with-text.svg": "8ddf",
	"./logo-genesis.svg": "8cec",
	"./logo-internal.svg": "5b0b",
	"./logo-lion.svg": "270b",
	"./logo-pos.svg": "d4f4",
	"./logo-sender.svg": "3364",
	"./logo-sub-console.svg": "324d",
	"./logo-vendor.svg": "96d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed6c";